import React from 'react';
import { Divider as EcoDivider } from "@bsw/react-nightingale";

export const Divider = (props) => {
    return <EcoDivider {...props}/>
}
